import type { ReputationInsightDto } from '@up2stay/up2promo-api-client';

/** Fill `{param}` placeholders of the dictionary template for an insight key. */
export function formatInsightText(
  templates: Record<string, string>,
  insight: ReputationInsightDto,
): string {
  const template = templates[insight.key];
  if (!template) return insight.key;
  return template.replace(/\{(\w+)\}/g, (_, key: string) =>
    String(insight.params[key] ?? ''),
  );
}
